
import { defineComponent,PropType,ref,Ref,provide,watchEffect,onMounted,computed } from 'vue';


export default defineComponent({
 emtis:["add_one","file_selected","remove_one"],
 props:{
      position:{
	type:Number as PropType<number>
      }
 },
 setup(props,context){
      
  const detectFile= (event:Event)=>{
      const inputf:HTMLInputElement=event.target as HTMLInputElement;
      context.emit("file_selected",{"file":inputf.files[0],"position":props.position});
  };
  const addInput = (event:Event)=>{
    event.preventDefault()
    context.emit("add_one","");
  };
  const removeInput =(event:Event)=>{
    context.emit("remove_one",{position:props.position});
  };
  return {detectFile,addInput,removeInput};
 }//fin de setup
});